import { render, staticRenderFns } from "./pjlist.vue?vue&type=template&id=a52a182a&scoped=true&"
import script from "./pjlist.vue?vue&type=script&lang=js&"
export * from "./pjlist.vue?vue&type=script&lang=js&"
import style0 from "./pjlist.vue?vue&type=style&index=0&id=a52a182a&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a182a",
  null
  
)

export default component.exports